'use strict';

var _objectSpread = require("/ecp-workspace/543932/enos-documentation-builder/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");
const fill = require('fill-range');
const utils = require('./utils');
const compile = function (ast) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const walk = function (node) {
    let parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const invalidBlock = utils.isInvalidBrace(parent);
    const invalidNode = node.invalid === true && options.escapeInvalid === true;
    const invalid = invalidBlock === true || invalidNode === true;
    const prefix = options.escapeInvalid === true ? '\\' : '';
    let output = '';
    if (node.isOpen === true) {
      return prefix + node.value;
    }
    if (node.isClose === true) {
      console.log('node.isClose', prefix, node.value);
      return prefix + node.value;
    }
    if (node.type === 'open') {
      return invalid ? prefix + node.value : '(';
    }
    if (node.type === 'close') {
      return invalid ? prefix + node.value : ')';
    }
    if (node.type === 'comma') {
      return node.prev.type === 'comma' ? '' : invalid ? node.value : '|';
    }
    if (node.value) {
      return node.value;
    }
    if (node.nodes && node.ranges > 0) {
      const args = utils.reduce(node.nodes);
      const range = fill(...args, _objectSpread(_objectSpread({}, options), {}, {
        wrap: false,
        toRegex: true,
        strictZeros: true
      }));
      if (range.length !== 0) {
        return args.length > 1 && range.length > 1 ? "(".concat(range, ")") : range;
      }
    }
    if (node.nodes) {
      for (const child of node.nodes) {
        output += walk(child, node);
      }
    }
    return output;
  };
  return walk(ast);
};
module.exports = compile;